/**
 * @fileoverview gRPC-Web generated client stub for TrafficUpdates
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// protoc-gen-grpc-web v1.4.2
// protoc              v4.23.1
// source: trafficUpdates.proto

/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as trafficUpdates_pb from './trafficUpdates_pb';


export class TrafficUpdatesGrpcServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorStreamFromServerCouriersLastPositions = new grpcWeb.MethodDescriptor(
    '/TrafficUpdates.TrafficUpdatesGrpcService/StreamFromServerCouriersLastPositions',
    grpcWeb.MethodType.SERVER_STREAMING,
    trafficUpdates_pb.CouriersLastPositionsRequest,
    trafficUpdates_pb.CouriersLastPositionsResponse,
    (request: trafficUpdates_pb.CouriersLastPositionsRequest) => {
      return request.serializeBinary();
    },
    trafficUpdates_pb.CouriersLastPositionsResponse.deserializeBinary
  );

  streamFromServerCouriersLastPositions(
    request: trafficUpdates_pb.CouriersLastPositionsRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<trafficUpdates_pb.CouriersLastPositionsResponse> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/TrafficUpdates.TrafficUpdatesGrpcService/StreamFromServerCouriersLastPositions',
      request,
      metadata || {},
      this.methodDescriptorStreamFromServerCouriersLastPositions);
  }

  methodDescriptorStreamFromServerCourierPositions = new grpcWeb.MethodDescriptor(
    '/TrafficUpdates.TrafficUpdatesGrpcService/StreamFromServerCourierPositions',
    grpcWeb.MethodType.SERVER_STREAMING,
    trafficUpdates_pb.CourierPositionsRequest,
    trafficUpdates_pb.CourierPositionsResponse,
    (request: trafficUpdates_pb.CourierPositionsRequest) => {
      return request.serializeBinary();
    },
    trafficUpdates_pb.CourierPositionsResponse.deserializeBinary
  );

  streamFromServerCourierPositions(
    request: trafficUpdates_pb.CourierPositionsRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<trafficUpdates_pb.CourierPositionsResponse> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/TrafficUpdates.TrafficUpdatesGrpcService/StreamFromServerCourierPositions',
      request,
      metadata || {},
      this.methodDescriptorStreamFromServerCourierPositions);
  }

}

